// --- src/components/common/RadioInput.jsx ---
import React from "react";

export default function RadioInput({ name, value, label, description, icon, checked }) {
    return (
        <label className="flex items-start gap-3 p-3 border rounded-lg cursor-pointer hover:border-blue-500">
            <input
                type="radio"
                name={name}
                value={value}
                checked={checked}
                className="mt-1 h-4 w-4 text-blue-600"
                onChange={() => { }}
            />
            {icon && <span className="mt-0.5">{icon}</span>}
            <div className="flex-1">
                <span className="font-medium text-gray-800">{label}</span>
                <p className="text-xs text-gray-500">{description}</p>
            </div>
        </label>
    );
}